import Shell from "../components/Shell";
import { useAuth } from "../context/AuthContext";

export default function PendingApproval() {
    const { user, logout } = useAuth();
    return (
        <Shell variant="public">
            <div className="max-w-2xl mx-auto px-6 py-24 text-center animate-fade-in">
                <p className="eyebrow mb-3">Account status</p>
                <h1 className="font-heading text-4xl font-light tracking-tight mb-4">Awaiting approval</h1>
                <p className="text-zinc-600 leading-relaxed mb-10 max-w-lg mx-auto">
                    Your application for <strong>{user?.clinic_name}</strong> is under manual review by the Dermalis team. We will email <strong>{user?.email}</strong> as soon as your account is approved — typically within 1–2 business days.
                </p>
                <button data-testid="pending-logout" onClick={logout} className="btn-secondary">Sign out</button>
            </div>
        </Shell>
    );
}
